export function createLookupSearchHandlers(component, grid, onError) {
  return {
    handleSearchInputChange(e) {
      const searchInput = e.target.value;
      component.setState({ searchInput, showErrorMessage: false, errorMessage: '' });
      if (searchInput.trim() === '' && grid.getState().search.trim() !== '') {
        grid.clearSearchIfNeeded(grid.getState().search).catch(onError);
      }
    },
    handleSearchSubmit(e) {
      e.preventDefault();
      const ref = component.searchInputRef;
      const search = (ref && ref.current ? ref.current.value : component.state.searchInput).trim();
      component.setState({ searchInput: search });
      return grid.submitSearch(search).catch(onError);
    },
  };
}
